import React from "react";
import {
  GlobalState,
  QuickButtonTypes,
} from "../../../../../../../../store/types";
import classNames from "classnames";
import { useSelector } from "react-redux";
//import "./styles.scss";

type Props = {
  button: QuickButtonTypes;
  onQuickButtonClicked: (event: any, value: string | number) => any;
};

function QuickButton({ button, onQuickButtonClicked }: Props) {
  const { dissableInput } = useSelector((state: GlobalState) => ({
    dissableInput: state.behavior.disabledInput,
  }));

  return (
    <button
      style={{
        cursor: dissableInput ? "not-allowed" : "pointer",
      }}
      className={classNames(`quick-button ${button.className}`, {
        disabled: dissableInput,
      })}
      disabled={dissableInput}
      onClick={(event) => onQuickButtonClicked(event, button.value)}
    >
      {button.label}
    </button>
  );
}

export default QuickButton;
